"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionEditorRating = void 0;
const InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
const FormQuestionType_1 = __importDefault(require("@opsbase/lib-form/FormQuestionType/FormQuestionType"));
const createFormQuestion_1 = __importDefault(require("@opsbase/lib-form/mutations/createFormQuestion"));
const RatingOption_1 = __importDefault(require("@opsbase/lib-form/RatingOption"));
const Flag_1 = __importDefault(require("@opsbase/lib-issue/Flag/Flag"));
const IssueType_1 = require("@opsbase/lib-issue/IssueType/IssueType");
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward/useCallforward"));
const useSysLang_1 = __importDefault(require("@opsbase/web-ctrl-syslang/SysLangController/useSysLang"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const ColorPicker_1 = __importDefault(require("@opsbase/web-pickers/ColorPicker"));
const TextFieldWithStateAndBlur_1 = __importDefault(require("@opsbase/web-textfield/TextFieldWithStateAndBlur"));
const react_1 = __importStar(require("react"));
const QuestionEditorConditionTreeButton_1 = __importDefault(require("../QuestionEditorConditionTreeButton"));
const QuestionEditorFailButton_1 = __importDefault(require("../QuestionEditorFailButton"));
const QuestionEditorIssueButton_1 = __importDefault(require("../QuestionEditorIssueButton"));
const QuestionEditorScoringButtonMenu_1 = __importDefault(require("../QuestionEditorScoringButtonMenu"));
exports.QuestionEditorRating = react_1.default.memo((props) => {
    const { scoring, config, onChange, immediateFailAvailable, qTitle, disabled } = props;
    const { isAlt, language } = (0, useSysLang_1.default)();
    const doChange = (0, react_1.useMemo)(() => (t, newOption) => {
        const newConfig = Object.assign(Object.assign({}, config), { [t]: newOption });
        onChange(newConfig);
    }, [config, onChange]);
    const handleChangeFlag = (0, useCallforward_1.default)((t) => flag => {
        const option = Object.assign({}, config[t]);
        option.flag = flag;
        doChange(t, option);
    }, [config, doChange]);
    const handleChangeLabel = (0, useCallforward_1.default)((t) => label => {
        const option = Object.assign({}, config[t]);
        if (isAlt) {
            option.labelAlt = Object.assign(Object.assign({}, option.labelAlt), { [language]: label });
            if (!option.label)
                option.label = label;
        }
        else {
            option.label = label;
        }
        doChange(t, option);
    }, [config, doChange, isAlt, language]);
    const handleChangeScore = (0, useCallforward_1.default)((t) => score => {
        const option = Object.assign({}, config[t]);
        option.score = score;
        doChange(t, option);
    }, [config, doChange]);
    const handleClickMarkFail = (0, useCallforward_1.default)((t) => () => {
        const option = Object.assign({}, config[t]);
        option.fail = !option.fail;
        doChange(t, option);
    }, [config, doChange]);
    const handleClickCondition = (0, useCallforward_1.default)((t, placeholder) => () => {
        var _a;
        const option = Object.assign({}, config[t]);
        const subQuestions = option.subQuestions;
        const enabled = subQuestions ? !subQuestions.enabled : false;
        //remove issue question if we are disabling
        const questions = subQuestions.questions
            ? enabled
                ? subQuestions.questions
                : ((_a = subQuestions.questions) === null || _a === void 0 ? void 0 : _a.filter(q => q.type !== FormQuestionType_1.default.ISSUE)) || []
            : [];
        option.subQuestions = {
            sqId: subQuestions ? subQuestions.sqId : '',
            enabled,
            questions,
        };
        option.label = option.label || placeholder;
        doChange(t, option);
    }, [config, doChange]);
    const handleClickAddIssueQuestion = (0, useCallforward_1.default)((t) => (value, placeholder) => {
        var _a, _b;
        const option = Object.assign({}, config[t]);
        const subQuestions = option.subQuestions;
        let questions = ((_a = subQuestions === null || subQuestions === void 0 ? void 0 : subQuestions.questions) === null || _a === void 0 ? void 0 : _a.filter(q => !!q.title)) || [];
        const isIssueQuestionFound = (_b = subQuestions.questions) === null || _b === void 0 ? void 0 : _b.some(q => q.type === FormQuestionType_1.default.ISSUE);
        if (!isIssueQuestionFound) {
            questions = questions.concat((0, createFormQuestion_1.default)({
                title: 'Please include details',
                type: FormQuestionType_1.default.ISSUE,
                config: {
                    [FormQuestionType_1.default.ISSUE]: {
                        title: 'Problem with ' + qTitle,
                        type: IssueType_1.DefaultIssueTypeKeys.UNSPECIFIED,
                        flag: Flag_1.default.RED,
                    },
                },
            }));
        }
        else {
            questions = questions.filter(q => q.type !== FormQuestionType_1.default.ISSUE);
        }
        option.label = option.label || placeholder;
        option.subQuestions = {
            sqId: subQuestions ? subQuestions.sqId : '',
            enabled: subQuestions ? !subQuestions.enabled : false,
            questions: subQuestions ? questions || [] : [],
        };
        doChange(t, option);
    }, [config, doChange, qTitle]);
    return (react_1.default.createElement(Vertical_1.default, null, Object.values(RatingOption_1.default).map((t, idx) => {
        var _a;
        const option = config[t];
        const { label, labelAlt, flag, subQuestions, score, fail } = option;
        const placeholder = idx + 1 + (idx === 0 ? ' star' : ' stars');
        const lLabel = isAlt ? (labelAlt === null || labelAlt === void 0 ? void 0 : labelAlt[language]) || label : label;
        return (react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { disabled: disabled, key: idx, value: lLabel, fullWidth: true, placeholder: placeholder, onBlur: handleChangeLabel(t), InputProps: {
                startAdornment: scoring ? (react_1.default.createElement(InputAdornment_1.default, { position: "start" },
                    react_1.default.createElement(QuestionEditorScoringButtonMenu_1.default, { disabled: disabled, score: score, onChange: handleChangeScore(t) }))) : undefined,
                endAdornment: (react_1.default.createElement(InputAdornment_1.default, { position: "end" },
                    react_1.default.createElement(ColorPicker_1.default, { disabled: disabled, noMargin: true, noBorder: true, value: flag, onChange: handleChangeFlag(t) }),
                    immediateFailAvailable && (react_1.default.createElement(QuestionEditorFailButton_1.default, { disabled: disabled, enable: fail, onClick: handleClickMarkFail(t) })),
                    react_1.default.createElement(QuestionEditorConditionTreeButton_1.default, { disabled: disabled, enable: (subQuestions === null || subQuestions === void 0 ? void 0 : subQuestions.enabled) ? subQuestions.enabled : false, isLabel: true, onClick: handleClickCondition(t, placeholder) }),
                    react_1.default.createElement(QuestionEditorIssueButton_1.default, { enable: (subQuestions === null || subQuestions === void 0 ? void 0 : subQuestions.enabled) &&
                            ((_a = subQuestions === null || subQuestions === void 0 ? void 0 : subQuestions.questions) === null || _a === void 0 ? void 0 : _a.some(q => q.type === FormQuestionType_1.default.ISSUE)), disabled: disabled, isLabel: true, onClick: handleClickAddIssueQuestion(t, placeholder) }))),
            } }));
    })));
});
exports.default = exports.QuestionEditorRating;
